import { render } from "./outlet-comp.vue?vue&type=template&id=6aa12e9b&scoped=true"
import script from "./outlet-comp.vue?vue&type=script&lang=js"
export * from "./outlet-comp.vue?vue&type=script&lang=js"

import "./outlet-comp.vue?vue&type=style&index=0&id=6aa12e9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa12e9b"]])

export default __exports__